import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  root: {
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
    cursor: 'pointer',
    padding: pxToRem(16),
    width: '100%',
    selectors: {
      '&:hover': {
        backgroundColor: theme.palette.neutralLighter,
        textDecoration: 'none',
      },
      '&:active': {
        backgroundColor: theme.palette.neutralLight,
        textDecoration: 'none',
      },
    },
  },
  iconContainer: {
    alignSelf: 'center',
    justifyContent: 'center',
  },
  icon: {
    fontSize: pxToRem(16),
    height: pxToRem(20),
    width: pxToRem(20),
  },
  labelContainer: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    selectors: {
      [layout.breakpoints.min.md]: {
        width: pxToRem(220),
      },
    },
  },
  label: {
    fontSize: pxToRem(14),
    fontWeight: 400,
    color: theme.palette.black,
  },
  secondaryLabelContainer: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    selectors: {
      [layout.breakpoints.min.md]: {
        width: pxToRem(100),
      },
    },
  },
  tertiaryLabelContainer: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    selectors: {
      [layout.breakpoints.min.md]: {
        width: pxToRem(128),
      },
    },
  },
  description: {
    fontSize: pxToRem(12),
    fontWeight: 400,
    color: theme.palette.neutralSecondary,
  },
});
